import { z } from 'zod';

const UploadCADProductNameSchema = z
  .string()
  .min(1, { message: 'Product Name must not be empty' })
  .max(256, { message: 'Product Name must not exceed 256 characters' });

const UploadCADFileSchema = z.custom<File | null>(
  (data: unknown) => {
    if (data == null || !(data instanceof File) || !data.name.endsWith('.zip') || data.size < 1) {
      return false;
    }

    return data;
  },
  (input: unknown) => {
    if (input == null) {
      return { message: 'CAD file is required' };
    }

    if (input instanceof File) {
      if (!input.name.endsWith('.zip')) {
        return { message: 'Please upload your CAD file in ZIP format' };
      }

      if (input.size < 1) {
        return { message: 'CAD file must not be empty' };
      }
    }

    return { message: 'CAD file is required' };
  }
);

export const uploadCADFormSchema = z.object({
  productName: UploadCADProductNameSchema,
  file: UploadCADFileSchema,
});

export type UploadCADFormSchema = z.infer<typeof uploadCADFormSchema>;
